<template>
  <el-form-item style="width:220px;height:150px" prop="name">
    <span class="img-remove" v-if="imgurl" @click="removeImg">
      x
    </span>
    <el-upload class="uploader" :auto-upload="false" ref="elUploadRef" :show-file-list="false" :multiple="false"
      action="" :on-change="uploadImg">
      <div style="width:220px;height:150px" v-if="imgurl" @click.stop="showBig">
        <img :src="imgurl" :class="imgTitle == 'yyzz' ? 'yyzz' : ''" class="avatar" alt="" />
      </div>
      <div v-else class="div-img-icon">
        <i class="el-icon-upload avatar-uploader-icon"></i>
        <div class="el-upload-text">
          <slot name="centerName"></slot>
        </div>
      </div>
    </el-upload>
    <!-- :class="imgTitle == 'yyzz' ? 'bigimg-father-yyzz' : 'bigimg-father'" -->
    <div class="bigimg-father" v-if="bigimg">
      <span class="bigimg-remove" v-if="bigimg">
        <i class="el-icon-refresh" style="color:#7b7b7b" @click="revolveBig"></i>
        <i @click="removeBig">✗</i>
      </span>
      <!-- :style="imgTitle == 'yyzz'? 'width:450px;height:660px': 'width:660px;height:450px'" -->
      <img style="width:660px;height:450px" :style="'transform:rotate(' + revolve + 'deg)'" :src="bigimg" alt="" />
    </div>
  </el-form-item>
</template>
<script>
/* eslint-disable */
import { submitDiscernLicense, recognitionDiscernBankCard, recognitionDiscernFrontID, recognitionDiscernBackID } from "@/api/service.js";
import { serviceUploadImg, serviceDownLoadImg } from "@/api/service.js";
import { testR } from "@/api/common";
export default {
  name: "uploadImg",
  // inject:["mask"],
  data() {
    return {
      imgurl: "",
      info: {},
      imgstr: "",
      bigimg: "",
      access_token: localStorage.getItem("token"),
      revolve: 0
    };
  },
  props: {
    imgTitle: String,
    imgsrc: String,
    removeS: Boolean,
    mediaNo: String
  },
  watch: {
    imgsrc(item1, item2) {
      this.imgurl = item1;
    }
  },
  async mounted() {
    try {
      if (this.mediaNo && this.mediaNo !== "") {
        const res = await serviceDownLoadImg(this.mediaNo);
        this.imgurl = "data:image/png;base64," + res;
      }
    } catch (e) {
      console.log("下载图片失败", e);
    }

  },
  methods: {
    showBig() {
      this.bigimg = this.imgurl;
      // this.mask();
    },
    removeImg() {
      this.revolve = 0;
      this.imgurl = "";
      this.$emit("removeImg", this.imgTitle);
    },
    removeBig() {
      this.bigimg = "";
    },
    uploadImg(file) {
      /* console.log(this.imgTitle);
      console.log(this.imgsrc);
      console.log(this.removeS);
      console.log("file--------------------", file); */
      var that = this;
      var reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = async function () {
        const formData = new FormData();
        formData.append("files", file.raw);
        let media_data = {};
        const media = await serviceUploadImg(
          formData
        );
        //TODO:文件上传识别的问题==============
        if (!testR(media)) {
          return;
        } else media_data = media.data.resp_data;
        that.imgurl = reader.result;
        if (that.imgTitle === "yyzz") {
          try {
            const base64img = that.imgurl.split(",");
            const res = await submitDiscernLicense(base64img[1]);
            //console.log("上传营业执照返回：", res);
            if (that.testR(res)) {
              that.$emit("getReturn", {
                img_info: res.data.resp_data,
                title: that.imgTitle,
                media_no: media_data[0].media_no
              });
            } else {
              if (res.data && res.data.return_msg.indexOf("Unterminated string. Expected delimiter") > 0) {
                that.warnMessage("识别失败请重试！");
                that.$refs.elUploadRef.clearFiles();
              }
            }
          } catch (e) {
            that.warnMessage(JSON.stringify(e));
          }
        }
        else if (that.imgTitle === "bank") {
          try {
            const base64BankImg = that.imgurl.split(",");
            const res = await recognitionDiscernBankCard(base64BankImg[1]);
            //console.log("银行卡", res);
            if (that.testR(res)) {
              that.$emit("getReturn", {
                img_info: res.data.resp_data,
                title: that.imgTitle,
                media_no: media_data[0].media_no
              });
            } else {
              if (res.data && res.data.return_msg.indexOf("Unterminated string. Expected delimiter") > 0) {
                that.warnMessage("识别失败请重试！");
                that.$refs.elUploadRef.clearFiles();
              }
            }
          } catch (e) {
            that.warnMessage(JSON.stringify(e));
          }
        } else if (that.imgTitle === "zm" || that.imgTitle === "beneficiary_zm") {
          try {
            const base64ZMImg = that.imgurl.split(",");
            //console.log("正面-------------", base64ZMImg);
            const res = await recognitionDiscernFrontID(base64ZMImg[1]);
            //console.log("身份证正面", res);
            if (that.testR(res)) {
              that.$emit("getReturn", {

                img_info: res.data.resp_data,
                title: that.imgTitle,
                media_no: media_data[0].media_no

              });
            } else {
              if (res.data && res.data.return_msg.indexOf("Unterminated string. Expected delimiter") > 0) {
                that.warnMessage("识别失败请重试！");
                that.$refs.elUploadRef.clearFiles();
              }
            }
          } catch (e) {
            that.warnMessage(JSON.stringify(e));
          }
        } else if (that.imgTitle === "fm" || that.imgTitle === "beneficiary_fm") {
          try {
            const base64FMImg = that.imgurl.split(",");
            const res = await recognitionDiscernBackID(base64FMImg[1]);
            //console.log("身份证反面", res);
            if (that.testR(res)) {
              //console.log("res-----------------------------------=================================");
              that.$emit("getReturn", {
                img_info: res.data.resp_data,
                title: that.imgTitle,
                media_no: media_data[0].media_no
              });
            } else {
              if (res.data && res.data.return_msg.indexOf("Unterminated string. Expected delimiter") > 0) {
                that.warnMessage("识别失败请重试！");
                that.$refs.elUploadRef.clearFiles();
              }
            }
          } catch (e) {
            that.warnMessage(JSON.stringify(e));
          }
        } else {

          that.$emit("getReturn", {
            img_info: {},
            title: that.imgTitle,
            media_no: media_data[0].media_no
          });

        }
      };
    },
    revolveBig() {
      this.revolve += 90;
      if (this.revolve >= 360) {
        this.revolve = 0;
      }
    }
  }
};
</script>
<style scoped>
.bigimg-father {
  width: auto;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

.bigimg-father-yyzz {
  width: auto;
  height: auto;
  position: fixed;
  top: 30px;
  z-index: 100;
}

.img-remove {
  height: 20px;
  width: 20px;
  position: absolute;
  right: 20px;
  background-color: rgb(199, 49, 49);
  line-height: 1.4;
  text-align: center;
  color: #fff;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 5px;
  margin: 0 -20px 0 0;
  z-index: 10;
  cursor: pointer;
}

.bigimg-remove {
  height: 60px;
  width: 120px;
  position: fixed;
  right: -100px;
  font-size: 60px;
  color: rgb(199, 49, 49);
  text-align: center;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 5px;
  margin: 0 -20px 0 0;
  z-index: 1-1;
  cursor: pointer;
}

.el-upload-text {
  color: rgb(99, 99, 99);
}

.avatar {
  width: 220px;
  height: 150px;
  border-radius: 6px;
  /* margin-top: -5px; */
}

.uploader {
  border: 1px dashed #97979770;
  width: 220px;
  height: 150px;
  /*   text-align: center;
  cursor: pointer; */
  border-radius: 6px;
}

.div-img-icon {
  /* margin-top: 40px; */
  width: 220px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-img-icon>>>i {
  color: rgba(0, 255, 255, 0);
  display: none;
}

.yyzz {
  width: 150px;
  height: 220px;
  transform: rotate(-90deg);
  margin-top: -35px;
}

i {
  font-style: normal;
}

/* @keyframes revolve {
  from {
    transform:rotate(90deg) ;
  }
  to {

  }
} */
</style>
